// Switching the mode of an account with several roles (STAGE_5 5.0). A switch is a new
// session in the other role, and the screen goes to that role's home.

import { App } from 'antd';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

import { homePath } from '@/app/navigation';
import { ru } from '@/i18n/ru';

import { useAuth, useCurrentUser, type Role } from './authContext';

export function useRoleSwitch() {
  const user = useCurrentUser();
  const { switchRole } = useAuth();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [pending, setPending] = useState(false);

  const switchTo = useCallback(
    async (role: Role) => {
      if (role === user.role) return;
      setPending(true);
      try {
        const next = await switchRole(role);
        void navigate(homePath(next.role), { replace: true });
      } catch {
        void message.error(ru.header.switchFailed);
      } finally {
        setPending(false);
      }
    },
    [message, navigate, switchRole, user.role],
  );

  return { roles: user.roles, active: user.role, canSwitch: user.roles.length > 1, pending, switchTo };
}
